import {
  NumberInput as ChakraNumberInput,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  forwardRef,
} from '@chakra-ui/react';
import type { NumberInputProps as ChakraNumberInputProps } from '@chakra-ui/react';

export type NumberInputProps = ChakraNumberInputProps & {
  hideIncrementStepper?: boolean;
  hideDecrementStepper?: boolean;
};

export const NumberInput = forwardRef<NumberInputProps, 'div'>(
  (
    { children, hideIncrementStepper, hideDecrementStepper, ...restProps },
    ref,
  ) => {
    return (
      <ChakraNumberInput ref={ref} {...restProps}>
        {children}
        {(!hideIncrementStepper || !hideDecrementStepper) && (
          <NumberInputStepper>
            {!hideIncrementStepper && <NumberIncrementStepper />}
            {!hideDecrementStepper && <NumberDecrementStepper />}
          </NumberInputStepper>
        )}
      </ChakraNumberInput>
    );
  },
);
NumberInput.displayName = 'NumberInput';
